/** PulseLogic.ai logo; swaps to the light-wordmark variant in dark mode. */
export default function Logo({ height = 26 }: { height?: number }) {
  return (
    <picture className="logo">
      <source srcSet="/brand/pulselogic-logo-dark.png" media="(prefers-color-scheme: dark)" />
      <img src="/brand/pulselogic-logo.png" alt="PulseLogic.ai" height={height} style={{ height, width: "auto" }} />
    </picture>
  );
}
